/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { accessControlService } from '../AccessControlService';
import { GroupState } from '../Model/AccessControlModel';
import { Loader } from '../../../../Common/Components/Loader';
import { DragableUI } from './BaseDragable';

interface Props {
  username: string;
  setselectedUserGroups: React.Dispatch<React.SetStateAction<string[]>>;
}

const UserGroupDragable = ({ username, setselectedUserGroups }: Props) => {
  const [loading, setLoading] = useState(true);
  const [liststate, setListState] = useState<GroupState>({
    unselectedlist: [],
    selectedlist: [],
  });

  useEffect(() => {
    if (username === '') {
      loadAvailableGroups().catch((err) => console.log(err));
    } else {
      loadUserAndAvailableGroups().catch((err) => console.log(err));
    }
  }, [username]);

  const loadUserAndAvailableGroups = async () => {
    setLoading(true);
    const userandavailablegroups =
      await accessControlService.getUserAndAvailableGroups(username);
    setListState({
      unselectedlist: userandavailablegroups.AvailableGroups.map(
        (x) => x.GroupName,
      ),
      selectedlist: userandavailablegroups.UserGroups.map((x) => x.GroupName),
    });
    setselectedUserGroups(
      userandavailablegroups.UserGroups.map((x) => x.GroupName),
    );
    setLoading(false);
  };

  const loadAvailableGroups = async () => {
    setLoading(true);
    const userandavailablegroups =
      await accessControlService.getAvailableGroups();
    setListState({
      unselectedlist: userandavailablegroups.AvailableGroups.map(
        (x) => x.GroupName,
      ),
      selectedlist: userandavailablegroups.UserGroups.map((x) => x.GroupName),
    });
    setLoading(false);
  };

  const parseItemId = (id: string) => {
    const lastDash = id.lastIndexOf('-');
    return {
      listId: id.substring(0, lastDash),
      index: parseInt(id.substring(lastDash + 1), 10),
    };
  };

  const onDragEnd = (event: any) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const { listId: startList, index: startIndex } = parseItemId(
      String(active.id),
    );
    const { listId: finishList, index: finishIndex } = parseItemId(
      String(over.id),
    );

    if (startList === finishList) {
      setListState((prevState) => {
        const newList = [...prevState[startList]];
        const [removed] = newList.splice(startIndex, 1);
        newList.splice(finishIndex, 0, removed);
        return { ...prevState, [startList]: newList };
      });
    } else {
      setListState((prevState) => {
        const sourceItems = [...prevState[startList]];
        const destItems = [...prevState[finishList]];
        const [removed] = sourceItems.splice(startIndex, 1);
        destItems.splice(finishIndex, 0, removed);

        const updatedState: GroupState = {
          ...prevState,
          [startList]: sourceItems,
          [finishList]: destItems,
        };

        setselectedUserGroups(updatedState.selectedlist);
        return updatedState;
      });
    }
  };

  return (
    <>
      {loading ? (
        <Loader loading={loading} />
      ) : (
        <DragableUI
          onDragEnd={onDragEnd}
          liststate={liststate}
          sourceList="Available Groups"
          destListTitle="Selected Groups"
        />
      )}
    </>
  );
};

export default UserGroupDragable;
